import { gql } from "@apollo/client";

export const GET_VOUCHERDEFS = gql`
  query Voucherdefs($vestiging_id: Int!, $id: [Int], $title: String, $pageSize: Int, $page: Int) {
    voucherdefs(vestiging_id: $vestiging_id, id: $id, title: $title, first: $pageSize, page: $page) {
      data {
        id
        title
        vestiging_id
      }
      paginatorInfo {
        perPage
        currentPage
        total
      }
    }
  }
`;
